export const COSTAR_COLUMN_MAP = {
  "property address": "address",
  "city": "city",
  "state": "state",
  "market name": "market",
  "submarket name": "submarket",
  "class": "classification",
  "rba": "rba",
  "land area (ac)": "land_area",
  "year built": "year_built",
  "year renovated": "year_renovated",
  "for sale status": "for_sale_status",
  "for sale price": "for_sale_price",
  "last sale date": "last_sale_date",
  "last sale price": "last_sale_price",
  "percent leased": "percent_leased",
  "owner name": "owner_name",
  "ceiling ht": "ceiling_ht",
  "number of loading docks": "loading_docks",
  "drive ins": "drive_ins",
  "construction material": "construction_material",
  "leasing company name": "leasing_company",
  "leasing company contact": "leasing_contact",
};
